import { UserData } from "./types";

export const initialData: Record<string, UserData> = {
  "/": {
    content: [],
    root: {
      props: {
        live: false,
        language: "tr",
        headerProfile: 1,
        meta: {
          seo_title: "Lorem Ipsum SEO Title",
          seo_desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
          canonical_url: "https://example.com",
          no_index: false,
          seo_icon: "https://example.com/default-icon.png",
          slug: "tr/test",
          name: "Test Page",
        },
        headerBannerShow: true,
        headerContactOptionsShow: true,
      },
    },
    zones: {},
  },
};
